import { ReactNode } from 'react'
import { Auth0Provider, Auth0ProviderOptions } from '@auth0/auth0-react'
import { useNavigate } from 'react-router'
import { Roles } from './'

const auth0Domain = import.meta.env.VITE_AUTH0_DOMAIN
const auth0ClientId = import.meta.env.VITE_AUTH0_CLIENT

export const Auth0ProviderWithNavigate = ({
  children
}: {
  children: ReactNode
}) => {
  const navigate = useNavigate()

  const onRedirectCallback: Auth0ProviderOptions['onRedirectCallback'] = (
    _,
    user
  ) => {
    if (user?.role === Roles.AnalyticsOnly) {
      navigate('/analytics/compensation')

      return
    }

    navigate('/')
  }

  return (
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      useRefreshTokens={import.meta.env.DEV}
      cacheLocation={import.meta.env.DEV ? 'localstorage' : 'memory'}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: 'dashboard-api'
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  )
}
